
<template>
  <div class="pr-1">
    <component v-if="Hide"
        :is="propTag"   
        :class="Class" 
        :id="Name"
        :title="isTruncated ? Text : ''"
        :ref="titleRef"
        v-b-tooltip.hover
        :style="StyleProp"
        >            
          <b-icon v-if="VisibleAdd"
              @click="ClickAdd"
              icon="plus" 
              v-b-tooltip.hover.top="$t('Shared.Add')+' '+this.IconAddDescription" 
              class="rounded-circle editTitleButton mr-1" 
              scale=".5" 
              font-scale="1.3">
          </b-icon> 

         <!-- <b-icon v-if="VisibleAddBlank"
            @click="ClickAddBlank"
            icon="plus-circle-fill" 
            v-b-tooltip.hover.top="$t('Shared.Add')+' '+this.BlankDescription" 
            class="rounded-circle editTitleButton mr-1" 
            scale=".5" 
            font-scale="1.3">
          </b-icon> -->

          <span v-if="VisibleAddBlank"
            @click="ClickAddBlank"
            v-b-tooltip.hover.top="$t('Shared.Add')+' '+this.BlankDescription" 
            class="rounded-circle editTitleButton ikon med-plus mr-1">
          </span>


          <b-icon v-if="VisibleAddExisting"
            @click="ClickAdd"
            icon="shield-fill-plus" 
            v-b-tooltip.hover.top="$t('Shared.Add')+' '+this.ExistingDescription" 
            class="rounded-circle editTitleButton mr-1" 
            scale=".5" 
            font-scale="1.3">
          </b-icon> 

         <!-- <b-icon v-if="VisibleEdit"
            @click="ClickIcon"
            icon="pencil-fill" 
            v-b-tooltip.hover.top="$t('Shared.Edit')" 
            class="rounded-circle editTitleButton mr-1" 
            scale=".5" 
            font-scale="1.3">
          </b-icon>-->

          <span v-if="VisibleEdit" 
            @click="ClickIcon" 
            v-b-tooltip.hover.top="$t('Shared.Edit')" 
            class="rounded-circle editTitleButton ikon med-pen mr-1">
          </span>

          <!--<b-icon v-if="VisiblePrint"
            @click="ClickPrint"
            icon="printer-fill" 
            v-b-tooltip.hover.top="this.IconPrintDescription" 
            class="rounded-circle editTitleButton mr-1" 
            scale=".5" 
            font-scale="1.3">
          </b-icon> -->
          <span v-if="VisiblePrint"
              @click="ClickPrint"
              v-b-tooltip.hover.top="this.IconPrintDescription"
              class="rounded-circle editTitleButton ikon med-print mr-1">
          </span>
          
         <!--<b-icon v-if="VisibleDownload"
              @click="ClickDownload"
              icon="cloud-download-fill" 
              v-b-tooltip.hover.top="$t('Shared.Download')" 
              class="rounded-circle editTitleButton mr-1" 
              scale=".5" 
              :style="ReadOnlyDownload ? 'pointer-events: none; opacity: 0.5;' : ''"
              font-scale="1.3">
           </b-icon>-->
          <span  v-if="VisibleDownload" 
            class="rounded-circle tableActionBTN tableBTNtext ikon med-cloud-download-fill"
            v-b-tooltip.hover.top="$t('Shared.Download')" 
            :style="ReadOnlyDownload ? 'pointer-events: none; opacity: 0.5; padding: .2em!important;' : 'padding: .2em!important;'"
            @click="ClickDownload">
          </span>
           
     
           <span v-if="VisibleDownload1"
            @click="ClickDownload1" 
            class="rounded-circle tableActionBTN tableBTNtext ikon med-cloud-download-fill"
            v-b-tooltip.hover.top="$t('Shared.Download')" 
            :style="ReadOnlyDownload1 ? 'pointer-events: none; opacity: 0.5; padding: .2em!important;' : 'padding: .2em!important;'">
          </span>

           <span v-if="VisibleEmail"
              class="rounded-circle tableActionBTN tableBTNtext ikon med-email"
              :style="ReadOnlyEmail ? 'pointer-events: none; opacity: 0.5;padding: .2em!important;' : 'padding: .2em!important;'" 
              @click="ClickEmail"
             v-b-tooltip.hover.top="$t('Shared.Email')" >
            </span>
       

        <span v-if="VisibleEmail1"
            class="rounded-circle tableActionBTN tableBTNtext ikon med-email"
            :style="ReadOnlyEmail1 ? 'pointer-events: none; opacity: 0.5;padding: .2em!important;' : 'padding: .2em!important;'" 
            @click="ClickEmail1"
            v-b-tooltip.hover.top="$t('Shared.Email')" >
        </span>


      
        <span v-if="VisibleTrash" 
          v-b-tooltip.hover.top="$t('Shared.TitleDelete')"
          class="rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-bin" 
          :style="ReadOnlyTrash ? 'pointer-events: none; opacity: 0.5;padding: .2em!important;' : 'padding: .2em!important;'" 
          @click="ClickTrash">
        </span>

         <b-icon v-if="VisibleInfo"
          @click="ClickInfo"
          icon="info-circle-fill" 
          v-b-tooltip.hover.top="$t('Msg.Info')" 
          class="rounded-circle editTitleButton mr-1" 
          :style="ReadOnlyInfo ? 'pointer-events: none; opacity: 0.5;' : ''" 
          scale=".5" 
          font-scale="1.3">
        </b-icon> 

         <b-icon v-if="VisibleChat"
          @click="ClickChat"
          icon="chat-fill" 
          v-b-tooltip.hover.top="$t('Shared.ChatMerative')" 
          class="rounded-circle editTitleButton mr-1" 
          scale=".5" 
          font-scale="1.3">
        </b-icon>

        <span v-if="ReportPrint"
              @click="ClickPrint"
              v-b-tooltip.hover.top="$t('Shared.Report')"
              class="rounded-circle editTitleButton ikon med-print mr-1">
          </span>
         <span v-if="ExportPDF"
              @click="ClickExportPDF"
              v-b-tooltip.hover.top="$t('Shared.Export')" 
              class="rounded-circle editTitleButton ikon med-cloud-download mr-1">
          </span>
         <span v-if="SharedByEmail"
              @click="ShareByEmail"
              v-b-tooltip.hover.top="$t('Shared.Email')" 
              class="rounded-circle editTitleButton ikon med-email mr-1">
          </span>
         
          <div class="d-inline" v-html="Text"></div>
    </component>
  </div>
</template>

<script>
  export default {
    name: 'MdTitle',
    props: {
      IconAddDescription:String,
      Text:          String,
      isSubtitle:    Boolean,
      VisibleEdit :Boolean,
      VisibleAdd:Boolean,
      VisibleDownload:Boolean,
      VisibleDownload1:Boolean,
      ReadOnlyDownload:Boolean,
      ReadOnlyDownload1:Boolean,
      ReadOnlyEmail:Boolean,
      ReadOnlyTrash:Boolean,
      ReadOnlyInfo:Boolean,
      ReadOnlyEmail1:Boolean,
      VisibleEmail:Boolean,
      VisibleEmail1:Boolean,
      VisibleTrash:Boolean,
      isHide:        Boolean,
      Name:          String,
      titleRef: String,  
      StyleProp:String, 
      UseVHtml:Boolean,
      
      //TP
      VisibleAddBlank:Boolean,
      BlankDescription:String,
      VisibleAddExisting:Boolean,   
      ExistingDescription:String,
      IconPrintDescription:String,
      VisiblePrint:Boolean,
      SharedByEmail:Boolean,
      VisibleInfo:Boolean,
      VisibleChat:Boolean,
      ExportPDF:Boolean,
      ReportPrint:Boolean,

      propTag:{
        type: String,
        default: 'h4',
      },
    },
    data() {
      return {
          ReadOnlyDownloadLocal:this.ReadOnlyDownload,
          Class: this.isSubtitle ? "page-subtitle text-truncate" : "page-title text-truncate",
          Hide: this.isHide  ? false : true,
          isTruncated: false,
          isMovile: false
      }
    },
    methods:{
      ClickIcon(){
        this.$emit('ClickEdit');
      },

      ClickChat(){
        this.$emit('ClickChat');
      },

      ClickDownload(){    
        if(!this.ReadOnlyDownload)   
          this.$emit('ClickDownload');
      },

      ClickInfo(){
        this.$emit('ClickInfo');
      },

      ClickDownload1(){    
        if(!this.ReadOnlyDownload1)     
          this.$emit('ClickDownload1');
      },

      ClickEmail(){
        this.$emit('ClickEmail');
      },

      ClickEmail1(){
        this.$emit('ClickEmail1');
      },

      ClickTrash(){
        this.$emit('ClickTrash');
      },

      ClickAdd(){
        this.$emit('ClickAdd');
      },

      ClickAddBlank(){
        this.$emit('ClickAddTPBlank');
      },

      ClickPrint(){
        this.$emit('ClickPrint');
      },

      ShareByEmail(){
        this.$emit('ShareByEmail');
      },

      ClickExportPDF(){
        this.$emit('ExportPDF');
      },

      checkTruncation() {
        if (this.$refs[this.titleRef])
          this.isTruncated = this.$refs[this.titleRef].offsetWidth < this.$refs[this.titleRef].scrollWidth;
      },

      addEventListeners() {
        this.$el.addEventListener('mouseenter', this.checkTruncation);
        this.$el.addEventListener('mouseleave', this.checkTruncation);
        // Events for movile
        if ( this.isMovile ) {
          this.$el.addEventListener('touchstart', this.checkTruncation);
          this.$el.addEventListener('touchend', this.checkTruncation);
          this.$el.addEventListener('touchcancel', this.checkTruncation);
        }
        // Re-check on window resize
        window.addEventListener('resize', this.checkTruncation);
      },
      removeEventListeners() {
        this.$el.removeEventListener('mouseenter', this.checkTruncation);
        this.$el.removeEventListener('mouseleave', this.checkTruncation);
        // Events for movile
        if ( this.isMovile ) {
          this.$el.removeEventListener('touchstart', this.checkTruncation);
          this.$el.removeEventListener('touchend', this.checkTruncation);
          this.$el.removeEventListener('touchcancel', this.checkTruncation);
        }
        window.removeEventListener('resize', this.checkTruncation);
      },
    },
    mounted(){
      this.isMovile = this.$store.state.isMovile;
      // Initially check if truncated on mount
      this.$nextTick(() => {
        this.addEventListeners();
        this.checkTruncation();
      });
    },
    beforeDestroy() {
      this.removeEventListeners();
    }
  }
</script>